module.exports = __webpack_public_path__ + "img/gallery07.b20fe2cb.png";